<template>
  <div>
    <TablePublic
      :colLists="transRecordColLists"
      :tableData="data"
      :paginationFlag="false"
      summary
      :summary-method="transSummaryMethod"
    >
      <template slot="solts" slot-scope="scope">
        <el-button @click="lookDetailFile(scope.data.attachmentList, 'trans')" type="text" size="small" class="button"
          >照片视频</el-button
        >
        <el-button @click="handleHistory(scope.data, 'trans')" type="text" size="small" class="button"
          >历史修改记录</el-button
        >
      </template>
    </TablePublic>

    <Mdialog
      :title="operatDialog.title"
      :visible.sync="operatDialog.visible"
      :width="operatDialog.width"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="operatDialog.visible = false"
    >
      <component
        :ref="operatDialog.currentView"
        :is="operatDialog.currentView"
        :data="operatDialog.data"
        :formType="formType"
        :imgArr="imgArr"
        :videoArr="videoArr"
      >
        <template #modificationDesc_suffix="scope">
          <div v-if="formType === 'shipping_order'" @click="handleHistoryDetail(scope.data)" style="width: 150px">
            <span>“鲜果信息"修改</span>
            <span class="view_button">&lt;详情&gt;</span>
          </div>
        </template>
      </component>
    </Mdialog>

    <Mdialog
      title="鲜果信息修改详情"
      :visible.sync="freshModifcationDialog"
      width="50%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="freshModifcationDialog = false"
    >
      <ModifcationDetail :currContent="historyForm.currContent" :orignalContent="historyForm.orignalContent" />
    </Mdialog>
  </div>
</template>

<script>
import TablePublic from '@/components/tablePublic.vue'
import Mdialog from '@/components/Mdialog'
import Photo from '@/components/photo.vue'
import HistoryRecord from '../HistoryRecord.vue'
import ModifcationDetail from '@/views/pick/transport/components/ModifcationDetail.vue'

import { getAmdRecList } from '@/api/manage/amd-rec'

const formTypeMap = {
  weight: 'picking_batch_weigh',
  trans: 'shipping_order',
}
export default {
  name: 'TransportRecord',
  components: {
    TablePublic,
    Mdialog,
    Photo,
    HistoryRecord,
    ModifcationDetail,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const _this = this
    return {
      transRecordColLists: [
        {
          prop: 'bizNo',
          label: '运输单号',
          isTrue: true,
          width: 150,
        },
        {
          prop: 'freightDateTime',
          label: '运输时间',
          isTrue: true,
          width: 150,
          formatter(row) {
            return row.freightDateTime ? _this.parseTime(row.freightDateTime, '{y}-{m}-{d} {h}:{i}') : ''
          },
        },
        {
          prop: 'licensePlateNumber',
          label: '车牌号',
          isTrue: true,
        },
        {
          prop: 'itemFreightAmount',
          label: '运输费用（元）',
          isTrue: true,
          width: 150,
          formatter(row) {
            return _this.ThousandAndDecimal(row.itemFreightAmount)
          },
        },
        {
          prop: 'lockNumber',
          label: '锁号',
          isTrue: true,
        },
        {
          prop: 'plannedNetWeightPerUnit',
          label: '单筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'totalQuantity',
          label: '满筐总筐数',
          isTrue: true,
        },
        {
          prop: 'tailContainerWeight',
          label: '尾筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'totalNetWeight',
          label: '总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'geoPosDetails',
          label: '加工厂地址',
          isTrue: true,
          width: 150,
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],

      formType: '',
      historyForm: {},
      freshModifcationDialog: false,
        
      imgArr: [],
      videoArr: [],

      // 弹窗数据
      operatDialog: {
        visible: false, // 是否展示
        title: '', // 弹窗标题
        currentView: null, //当前组件
        width: '', // 弹窗宽度
        type: '', // 提交类型
        data: {}, // 数据
      },

      // 弹窗枚举
      operatEnum: {
        photo: () => {
          return {
            component: 'Photo',
            title: `查看照片视频`,
            width: '60%',
          }
        },
        historyRecord: () => {
          return {
            component: 'HistoryRecord',
            title: `历史修改记录`,
            width: '60%',
          }
        },
      },
    }
  },
  mounted() {},
  methods: {
    onOperat(type, row) {
      // 添加操作类型
      const { component, title, width } = this.operatEnum[type]()
      this.operatDialog.title = title
      this.operatDialog.width = width
      this.operatDialog.type = type
      this.operatDialog.data = row || {}
      this.operatDialog.currentView = component
      this.operatDialog.visible = true
    },
    lookDetailFile(list) {
      this.imgArr = list?.filter((item) => item.type == 2).map((item) => item.url) || []
      this.videoArr = list?.filter((item) => item.type == 3).map((item) => ({ fileUrl: item.url })) || []

      this.onOperat('photo', {})
    },
    transSummaryMethod(param) {
      const { columns, data } = param
      const sums = []

      if (!data) return sums

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 7) {
          const total = data.reduce((prev, cur) => {
            return prev + (Number(cur.totalQuantity) || 0)
          }, 0)
          sums[index] = this.myFixed(total, 2) || '-'
          return
        }
        if (index == 8) {
          const total = data.reduce((prev, cur) => {
            return prev + (Number(cur.tailContainerWeight) || 0)
          }, 0)
          sums[index] = this.myFixed(total, 2) || '-'
          return
        }
        if (index == 9) {
          const total = data.reduce((prev, cur) => {
            return prev + (Number(cur.totalNetWeight) || 0)
          }, 0)
          sums[index] = this.myFixed(total, 2) || '-'
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    async handleHistory(row, type) {
      this.formType = formTypeMap[type]

      let formId = formTypeMap[type] === formTypeMap.trans ? row.shippingOrderId : row.id

      const data = await getAmdRecList({ formId, formType: formTypeMap[type] })
      if (data.code == 200 && data.flag) {
        this.onOperat('historyRecord', data.data)
      }
    },
    handleHistoryDetail(data) {
      this.historyForm = {
        currContent: JSON.parse(data.currContent || '{}').itemList || [],
        orignalContent: JSON.parse(data.orignalContent || '{}').itemList || [],
      }
      this.freshModifcationDialog = true
    },
  },
}
</script>

<style scoped lang="less"></style>
